var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"emailBuilderContainer"}},[_c(_vm.targetBuilder,{tag:"component",attrs:{"email-template-starter":this.$route.query.template_name,"header-title":"New Email Template"},on:{"load-failure":_vm.showLoadError,"save":_vm.handleSave}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }